import { default as index } from './zh_CN/index';

export default Object.assign(
  {
    locale: 'zh_CN',
    pluralRuleFunction: () => {
      return 'other';
    }
  },
  index
);



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js